import PrevNextBtns from '@/components/calculators/components/PrevNextBtns';
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Mm100Page } from '../../index';
import css from './index.module.scss';
export const types_car = [
    { key: 'classA', img: '/img/calculators/mm100/step2-classA.jpg', i18n: 'classA' },
    { key: 'classB', img: '/img/calculators/mm100/step2-classB.jpg', i18n: 'classB' },
    { key: 'classC', img: '/img/calculators/mm100/step2-classC.jpg', i18n: 'classC' },
    { key: 'trailer', img: '/img/calculators/mm100/step2-trailer.jpg', i18n: 'trailer' },
];

export const types_house = [
    { key: '15m', img: '/img/calculators/mm100/step2-15m.jpg', i18n: '15m' },
    { key: '30m', img: '/img/calculators/mm100/step2-30m.jpg', i18n: '30m' },
    { key: '45m', img: '/img/calculators/mm100/step2-45m.jpg', i18n: '45m' },
];

export default function Step2({ data, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('shared');
    const [active, setActive] = useState(data?.type || '');
    const types = data?.scene === 'rv' ? types_car : types_house;

    const chooseType = (key: string) => {
        if (active !== key) {
            callBack({
                type: key,
                stepTitle: [data.stepTitle[0], key, ...data.stepTitle.slice(-5)],
            });
            setActive(key);
        }
    };

    const onNext = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator2',
            step: 'type',
            product_name: 'Ecoflow Power Kits',
            option_name: active,
            button_name: 'Next',
        });

        callBack({
            currentStep: data.currentStep + 1,
            currentPage: Mm100Page.Appliances,
            type: active,
        });
    };

    const onBack = () => {
        callBack({
            currentStep: data.currentStep - 1,
            currentPage: Mm100Page.Scenery,
            type: null,
            stepTitle: [data.stepTitle[0], 'type', ...data.stepTitle.slice(-5)],
        });
    };

    return (
        <div className={`step2 step ${css.step2}`}>
            <p className="step2-title">{data?.scene === 'rv' ? t('calculators.mm100.step2.title_RV') : t('calculators.mm100.step2.title_offGrid')}</p>
            <div className="step2-imgs">
                {types?.map((type: any) => (
                    <div
                        className={`step2-img ${data?.scene === 'rv' ? 'type-rv' : 'type-offGrid'} ${active === type.key ? 'active' : ''}`}
                        key={type.key}
                        style={{ width: `${100 / types?.length}%` }}
                        onClick={() => chooseType(type.key)}
                    >
                        <div className="img-item">
                            <Image
                                src={type?.img}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step2.${type.i18n}`)}
                                aria-label={t(`calculators.mm100.step2.${type.i18n}`)}
                            />
                        </div>
                        <div className="cover"></div>
                        {active === type.key && (
                            <div className="checkIcon">
                                <Image
                                    src="/img/calculators/mm100/selected.svg"
                                    width={44}
                                    height={44}
                                    className="fullImgs"
                                    alt={t(`calculators.mm100.step2.${type.i18n}`)}
                                    aria-label={t(`calculators.mm100.step2.${type.i18n}`)}
                                />
                            </div>
                        )}
                        <p className="sceneTitle">{t(`calculators.mm100.step2.${type.i18n}`)}</p>
                    </div>
                ))}
            </div>
            <div className="calculatorMm100-btnsArea">
                <PrevNextBtns canNext={active} onNext={onNext} onBack={onBack} />
            </div>
        </div>
    );
}
